<template>
  <form :id="'frm-'+id" class="px-3" method="post" onsubmit="return false">
    <div :aria-labelledby="id+'-title'"
         :data-id="name"
         :id="id"
         aria-hidden="true"
         class="modal fade"
         role="dialog"
         tabindex="-1">
      
      <div class="modal-dialog modal-dialog-scrollable modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header modal-body-scrolled pb-0">
            <h5 :id="id+'-title'" class="modal-title">Seleccione las líneas de investigación</h5>
          </div>
          <div class="modal-body overflow-x-hidden px-0 md:px-3">
            <div class="p-2 w-100 d-flex flex-wrap justify-content-center">
              <ul class="list-group list-group-flush mb-3">
                <li class="list-group-item d-flex justify-content-between align-items-center"
                    v-if="lines && lines.length && !loading"
                    v-for="line in lines"
                    :key="line.id">
                  <div class="list-group-item-body">
                    <div class="list-group-item-title">{{ line.title }}</div>
                    <div class="list-group-item-text">{{ line.leader ? line.leader.full_name : '' }}</div>
                  </div>
                  <div class="list-group-item-figure">
                    <label class="switcher-control">
                      <input type="checkbox"
                             name="onoffswitch"
                             class="switcher-input"
                             :checked="selected(line)"
                             @change="assignLineToProtocol(line)">
                      <span class="switcher-indicator"></span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="modal-footer flex justify-content-between px-2 shadow-none">
            <button @click="clearSearch" class="btn btn-secondary ml-2" data-dismiss="modal" type="button">Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
  import { mapActions, mapGetters } from 'vuex'
  import { find } from 'lodash'
  
  export default {
    name: 'ResearchLinesModal',
    props: {
      protocol: {
        type: Object,
      },
      id: {
        default: Math.guid(),
      },
    },
    data: () => ({
      name: null,
      loading: false,
    }),
    methods: {
      ...mapActions({
        getResearchLines: 'protocols/getResearchLines',
      }),
      
      clearSearch() {
      
      },
      selected(line) {
        const l = find(this.protocol.research_lines, l => line.id === l.id)
        
        return l !== undefined && l !== null
      },
      async assignLineToProtocol(line) {
      
      },
    },
    computed: {
      ...mapGetters({
        lines: 'protocols/researchLines',
      }),
    },
    async mounted() {
      this.name = this.id
      
      if(this.lines.length === 0) {
        this.loading = true
        
        await this.getResearchLines()
        
        this.loading = false
      }
    },
  }
</script>
